import axiosInstance from '../auth/axiosInstance';

export type ClientReportStatus = 'submitted' | 'edit' | 'upload';

export type AddOrUpdateReportOptions = {
  status?: ClientReportStatus;
  reportItemId?: string | null;
  replaceDraft?: boolean;
  copyFromReportItemId?: string | null;
  sourceHtmlPath?: string | null;
};

export const getSMEList = async () => {
  try {
    console.log('Fetching SME list...');

    const { data: result } = await axiosInstance.get('/Project/GetSMEUserList');

    console.log('sme list response:', result);

    if (result.data && Array.isArray(result.data)) {
      return result.data;
    }

    console.error('Unexpected response structure:', result);
    return [];
  } catch (error) {
    console.error('Error fetching sme:', error);
    return [];
  }
};

export const getSMEPendingProjectList = async () => {
  try {
    console.log('Fetching SME pending project list...');

    const { data: result } = await axiosInstance.get('/SME/GetPendingProjectList');

    console.log('SME pending project list response:', result);
    return result;
  } catch (error) {
    console.error('Error fetching SME pending projects:', error);
    return {
      projects: [],
      totalCount: 0,
    };
  }
};

export const addOrUpdateReport = async (
  projectId: number | string,
  userId: number | string,
  remarks: unknown,
  attachments: File[] | null | undefined,
  options: AddOrUpdateReportOptions = {}
) => {
  const status: ClientReportStatus = options.status ?? 'submitted';
  const reportItemId = options.reportItemId?.trim() || '';
  const replaceDraft = options.replaceDraft === true;
  const copyFromReportItemId = options.copyFromReportItemId?.trim() || '';
  const sourceHtmlPath = options.sourceHtmlPath?.trim() || '';

  console.log('projectId:', projectId);
  console.log('userId:', userId);
  console.log('remarks:', remarks);
  console.log('status:', status);
  console.log('reportItemId:', reportItemId || '(new)');
  console.log('attachments:', attachments);

  if (!projectId) {
    throw new Error('ProjectId is required');
  }
  if (!userId) {
    throw new Error('UserId is required');
  }

  let safeRemarks: string;
  if (typeof remarks === 'string') {
    safeRemarks = remarks.trim();
  } else if (remarks && typeof remarks === 'object' && 'remarks' in remarks) {
    safeRemarks = String((remarks as { remarks?: string }).remarks || '').trim();
  } else {
    safeRemarks = String(remarks || '').trim();
  }

  const file =
    attachments && Array.isArray(attachments)
      ? attachments.find((f) => f instanceof File)
      : undefined;

  if (!file && !reportItemId && !copyFromReportItemId) {
    throw new Error('Attach a report file before saving or submitting.');
  }

  const formData = new FormData();
  formData.append('ProjectId', String(parseInt(String(projectId), 10)));
  formData.append('UserId', String(parseInt(String(userId), 10)));
  formData.append('ReportItems[0].Remarks', safeRemarks);
  formData.append('ReportItems[0].Status', status);
  if (reportItemId) {
    formData.append('ReportItems[0].ReportItemId', reportItemId);
  }
  if (replaceDraft) {
    formData.append('ReportItems[0].ReplaceDraft', 'true');
  }
  if (copyFromReportItemId) {
    formData.append('ReportItems[0].CopyFromReportItemId', copyFromReportItemId);
  }
  if (sourceHtmlPath) {
    formData.append('ReportItems[0].SourceHtmlPath', sourceHtmlPath);
  }

  if (file instanceof File) {
    formData.append('file', file);
    console.log(
      'File attached:',
      file.name,
      'Size:',
      file.size,
      'Type:',
      file.type
    );
  } else {
    console.log('No new file to attach');
  }

  try {
    console.log('Making API call to:', '/Report/AddorUpdateReport');

    const { data: result, status: httpStatus } = await axiosInstance.post(
      '/Report/AddorUpdateReport',
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );

    console.log('Response status:', httpStatus);
    console.log('Success response:', result);
    return result;
  } catch (error: unknown) {
    const err = error as {
      response?: { data?: { message?: string } | string };
      message?: string;
    };
    const responseText =
      err.response?.data != null
        ? typeof err.response.data === 'string'
          ? err.response.data
          : JSON.stringify(err.response.data)
        : err.message;
    console.error('Error sending report:', responseText);
    throw new Error(
      err.response
        ? `Server error: ${
            typeof err.response.data === 'object' && err.response.data?.message
              ? err.response.data.message
              : responseText
          }`
        : err.message || 'Request failed'
    );
  }
};
